"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { TextScramble } from "./ui/text-scramble";

export function ShippingDialog({ children }: { children?: React.ReactNode }) {
  return (
    <Dialog>
      <DialogTrigger asChild className="cursor-pointer">
        {children ? (
          children
        ) : (
          <Button
            variant="link"
            className="text-sm text-muted-foreground hover:text-foreground"
          >
            SHIPPING & RETURNS
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            <TextScramble characterSet=". ">
              Shipping & Returns Policy
            </TextScramble>
          </DialogTitle>
          <DialogDescription>
            Information about our shipping and returns policy.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <h4 className="font-medium mb-2">Shipping</h4>
            <ul className="list-disc pl-4 space-y-2 text-sm text-muted-foreground">
              <li>Standard delivery within Tunisia: 7 TND</li>
              <li>Delivery time: 7-14 days</li>
              <li>Free pickup available Bardo/Downtown Tunis</li>
            </ul>
          </div>
          <div>
            <h4 className="font-medium mb-2">Returns</h4>
            <ul className="list-disc pl-4 space-y-2 text-sm text-muted-foreground">
              <li>We do not accept returns</li>
              {/* <li>Item must be unworn and in original condition</li>
              <li>Contact us before initiating a return</li> */}
            </ul>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
